/**
 * Serializes async operations so callers never race each other: each `run()`
 * call is chained after every previously enqueued task, regardless of whether
 * that task resolved or rejected. Used to make voice-channel connect/disconnect
 * and media mutations (mic/camera/screen-share toggles) execute strictly
 * one-at-a-time even when triggered concurrently from the UI.
 */
export class AsyncQueue {
  private tail: Promise<unknown> = Promise.resolve()

  run<T>(task: () => Promise<T>): Promise<T> {
    const result = this.tail.then(task)
    // Swallow the rejection on the chain itself (not on `result`) so one
    // failed task doesn't stop subsequent queued tasks from running, while
    // the caller of this particular `run()` still observes the real error.
    this.tail = result.then(
      () => undefined,
      () => undefined,
    )
    return result
  }
}
